import React from 'react'
import PropTypes from 'prop-types'

const FilterStatus = props => (
  <select
    className={`filter-header ${props.param.filterStatus === -1 ? 'no-space' : ''}`}
    onChange={props.submitFilters(props.param)}
    value={props.param.filterStatus}
  >
    <option value={-1}>
      Status
    </option>
    <option value={0}>Need review</option>
    <option value={2}>Rejected</option>
    <option value={3}>No Sample Provied</option>
  </select>
)

FilterStatus.propTypes = {
  submitFilters: PropTypes.func.isRequired,
  param: PropTypes.shape({
    filterStatus: PropTypes.number.isRequired,
  }).isRequired,
}

export default FilterStatus
